import React from 'react'
import load from "./Loader.gif"
function Loading({className}) {
    return (
        <>
            <div className={`items-center justify-center ${className}`}>
                <img src={load} alt=""/>
            </div>   
        </>
    )
}

export default Loading
